<template>
  <div class="contentPage">
    <NavBar titleTranslationPath="profileOverview.title" location commune />
    <div class="content">
      <slot></slot>
    </div>
    <TabBar />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import TabBar from '@/components/TabBar.vue';
import FeedbackContent from '@/views/feedback/FeedbackContent.vue';

export default {
  components: {
    NavBar,
    TabBar,
    FeedbackContent,
  },
};
</script>

<style scoped>
.content {
  padding: 20px 20px 100px;
  background-color: #f3f7f8;
  min-height: calc(100vh - 122px);
}
</style>
